import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Header.css";
import { Button, Container } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import instance from "../../services/endpoint.js";
import img from "../../images/Logo.png";
import { toast } from "react-toastify";
import Loader from "../utilComponents/loader.js";
import { FaUsers } from "react-icons/fa";
import { FaUserSecret, FaUsersGear } from "react-icons/fa6";

const SuperAdminHeader = ({ page }) => {
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Admin Dashboard | Bitstek Advisory"; // Set the document title
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const [userData, setUserData] = useState({
    FullName: "",
  });

  const fetchUserData = async () => {
    try {
      const response = await instance.get("/api/v1/superadmin/auth/profile");
      setUserData({
        FullName: response.data.FullName,
      });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleLogout = async () => {
    setLoading(true);
    try {
      await instance.post("/api/v1/superadmin/auth/logout");
      toast.success("Logout successful");
      navigate("/superadminlogin");
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();

  return (
    <Container
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "50px",
        backgroundColor: "black",
        zIndex: 1100,
        maxWidth: "100vw",
      }}>
      {loading && <Loader />}
      <header className={"header dark"}>
        <div className="header-content">
          <div
            className="logo"
            title="Bitstek Advisory"
            onClick={() => navigate("/superadmindashboard")}
            style={{ cursor: "pointer" }}>
            <img src={img} alt="Bitstek Advisory Logo" className="logo-image" />
          </div>
          <div className="Head-name">
            <span className="logo-text">Bitstek Advisory</span>
          </div>
          <div className="actions">
            {page === "register" || page === "login" ? (
              <div className="time">{currentTime}</div>
            ) : page === "dashboard" ? (
              <div className="profile-menu">
                <button
                  className="profile-button"
                  onClick={() => setShowDropdown(!showDropdown)}>
                  <FaBars />
                </button>
                {showDropdown && (
                  <div className="dropdown">
                    <div className="text-center dropdown-main">
                      <img src={img} alt="Bitstek Advisory Logo" />
                      <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        Hi, {userData.FullName}
                      </h5>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center mb-3">
                      <div
                        className="text-center header-icon"
                        style={{ margin: "10px", cursor: "pointer" }}
                        onClick={() => navigate("/superadminprofile")}>
                        <FaUserSecret
                          size={30}
                          color="#e2c25e"
                          className="me-4"
                        />
                        <p style={{ fontSize: "10px", margin: "5px 20px 0 0" }}>
                          Profile
                        </p>
                      </div>
                      <div
                        className="text-center header-icon"
                        style={{ margin: "10px", cursor: "pointer" }}
                        onClick={() => navigate("/superadmindashboard")}>
                        <FaUsers size={30} color="#e2c25e" />
                        <p style={{ fontSize: "10px", marginTop: "5px" }}>
                          Users
                        </p>
                      </div>
                      <div
                        className="text-center header-icon"
                        style={{ margin: "10px", cursor: "pointer" }}
                        onClick={() => navigate("/admin")}>
                        <FaUsersGear
                          size={30}
                          color="#e2c25e"
                          className="ms-4"
                        />
                        {/* <p className='mt-2 text-xs'>Admins</p> */}
                        <p style={{ fontSize: "10px", margin: "5px 0 0 18px" }}>
                          Admins
                        </p>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        variant="danger"
                        size="sm"
                        style={{ fontSize: "13px" }}
                        onClick={handleLogout}>
                        Logout
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </header>
    </Container>
  );
};

export default SuperAdminHeader;
